// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-output-template-shell {
  min-height: 100%;
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  background: #f8fafc;
}

.audit-output-template-sidebar {
  border-right: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.audit-output-template-sidebar-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.audit-output-template-sidebar-header h5,
.audit-output-template-toolbar h4 {
  margin: 0;
  font-weight: 700;
  color: #0f172a;
}

.audit-output-template-sidebar-header p,
.audit-output-template-toolbar p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.92rem;
}

.audit-output-template-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}

.audit-output-template-list-item {
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  background: #ffffff;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  cursor: pointer;
  transition: 0.2s ease;
}

.audit-output-template-list-item:hover,
.audit-output-template-list-item.is-active {
  border-color: #0f766e;
  box-shadow: 0 8px 24px rgba(15, 118, 110, 0.12);
}

.audit-output-template-list-item strong {
  color: #0f172a;
}

.audit-output-template-list-item span,
.audit-output-template-list-item small {
  color: #475569;
}

.audit-output-template-empty {
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #64748b;
}

.audit-output-template-main {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.audit-output-template-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.audit-output-template-toolbar-actions,
.audit-output-preview-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.audit-output-template-grid {
  display: grid;
  grid-template-columns: minmax(0, 540px) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.audit-output-template-editor,
.audit-output-template-preview-panel {
  min-width: 0;
}

.audit-output-template-preview-panel .card,
.audit-output-template-editor .card {
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.audit-output-template-editor .card-title,
.audit-output-template-preview-panel .card-title {
  font-weight: 700;
  color: #0f172a;
}

.audit-output-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.audit-output-field .form-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0;
  font-size: 0.82rem;
  color: #334155;
  font-weight: 600;
}

.audit-output-field-hint {
  font-size: 0.72rem;
  font-weight: 500;
  color: #64748b;
}

.audit-output-standard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
}

.audit-output-standard-option {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  background: #ffffff;
}

.audit-output-date-grid {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.audit-output-date-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.audit-output-coordinate-editor {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 14px;
  background: #f8fafc;
}

.audit-output-coordinate-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audit-output-coordinate-row {
  display: grid;
  grid-template-columns: minmax(130px, 1.2fr) repeat(4, minmax(64px, 0.7fr)) minmax(82px, 0.8fr) auto;
  gap: 8px;
  align-items: center;
}

.audit-output-coordinate-row strong {
  color: #0f172a;
  font-size: 0.84rem;
}

.audit-output-token-hint {
  border: 1px dashed #94a3b8;
  border-radius: 16px;
  padding: 14px;
  background: #ffffff;
  color: #334155;
  font-size: 0.86rem;
  line-height: 1.7;
}

.audit-output-preview-stage {
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
  padding-bottom: 20px;
}

.audit-output-preview-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.audit-output-template-loading,
.audit-output-template-loading-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 200px;
  color: #475569;
}

@media (max-width: 1400px) {
  .audit-output-template-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 960px) {
  .audit-output-template-shell {
    grid-template-columns: minmax(0, 1fr);
  }

  .audit-output-template-sidebar {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }
}

.audit-output-coordinate-row.is-selected-row {
  background: rgba(15, 118, 110, 0.07);
  border-radius: 6px;
  outline: 1.5px solid rgba(15, 118, 110, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditOutputTemplate/AuditOutputTemplate.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mGAAmG;EACnG,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;AACF;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,4CAA4C;AAC9C","sourcesContent":[".audit-output-template-shell {\n  min-height: 100%;\n  display: grid;\n  grid-template-columns: 300px minmax(0, 1fr);\n  background: #f8fafc;\n}\n\n.audit-output-template-sidebar {\n  border-right: 1px solid #e2e8f0;\n  background: #ffffff;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.audit-output-template-sidebar-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.audit-output-template-sidebar-header h5,\n.audit-output-template-toolbar h4 {\n  margin: 0;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.audit-output-template-sidebar-header p,\n.audit-output-template-toolbar p {\n  margin: 6px 0 0;\n  color: #64748b;\n  font-size: 0.92rem;\n}\n\n.audit-output-template-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-y: auto;\n}\n\n.audit-output-template-list-item {\n  border: 1px solid #cbd5e1;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: left;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.audit-output-template-list-item:hover,\n.audit-output-template-list-item.is-active {\n  border-color: #0f766e;\n  box-shadow: 0 8px 24px rgba(15, 118, 110, 0.12);\n}\n\n.audit-output-template-list-item strong {\n  color: #0f172a;\n}\n\n.audit-output-template-list-item span,\n.audit-output-template-list-item small {\n  color: #475569;\n}\n\n.audit-output-template-empty {\n  border: 1px dashed #cbd5e1;\n  border-radius: 16px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #64748b;\n}\n\n.audit-output-template-main {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.audit-output-template-toolbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.audit-output-template-toolbar-actions,\n.audit-output-preview-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.audit-output-template-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 540px) minmax(0, 1fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.audit-output-template-editor,\n.audit-output-template-preview-panel {\n  min-width: 0;\n}\n\n.audit-output-template-preview-panel .card,\n.audit-output-template-editor .card {\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.audit-output-template-editor .card-title,\n.audit-output-template-preview-panel .card-title {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.audit-output-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.audit-output-field .form-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 0;\n  font-size: 0.82rem;\n  color: #334155;\n  font-weight: 600;\n}\n\n.audit-output-field-hint {\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.audit-output-standard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 10px;\n}\n\n.audit-output-standard-option {\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  padding: 10px 12px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  cursor: pointer;\n  background: #ffffff;\n}\n\n.audit-output-date-grid {\n  margin-top: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.audit-output-date-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.audit-output-coordinate-editor {\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 14px;\n  background: #f8fafc;\n}\n\n.audit-output-coordinate-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.audit-output-coordinate-row {\n  display: grid;\n  grid-template-columns: minmax(130px, 1.2fr) repeat(4, minmax(64px, 0.7fr)) minmax(82px, 0.8fr) auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.audit-output-coordinate-row strong {\n  color: #0f172a;\n  font-size: 0.84rem;\n}\n\n.audit-output-token-hint {\n  border: 1px dashed #94a3b8;\n  border-radius: 16px;\n  padding: 14px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 0.86rem;\n  line-height: 1.7;\n}\n\n.audit-output-preview-stage {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow: auto;\n  padding-bottom: 20px;\n}\n\n.audit-output-preview-toolbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.audit-output-template-loading,\n.audit-output-template-loading-inline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 200px;\n  color: #475569;\n}\n\n@media (max-width: 1400px) {\n  .audit-output-template-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 960px) {\n  .audit-output-template-shell {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .audit-output-template-sidebar {\n    border-right: none;\n    border-bottom: 1px solid #e2e8f0;\n  }\n}\n\n.audit-output-coordinate-row.is-selected-row {\n  background: rgba(15, 118, 110, 0.07);\n  border-radius: 6px;\n  outline: 1.5px solid rgba(15, 118, 110, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
